import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import { Avatar } from "@mui/material";
import Food from "../../../../assets/images/order/food.png";

const FlexDivRow = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
}));

const FlexCenter = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: 15.89,
  height: 15.89,
  border: "2px solid #FF0000",
  borderRadius: 10,
  fontWeight: "500",
  fontSize: 12,
  color: "#FF0000",
  fontFamily: `Poppins, sans-serif`,
}));

const CardItem = () => {
  const [counter, setCounter] = useState(0);

  const handleDicrement = () => {
    counter > 0 && setCounter(counter - 1);
  };

  return (
    <FlexDivRow
      style={{
        width: 298,
        height: 52,
        background: "#E5E5E5",
        margin: "5px 0px",
      }}
    >
      <Avatar
        sx={{
          width: "46px",
          height: "46px",
          marginLeft: 1,
        }}
        variant="square"
        src={Food}
      />

      <div
        style={{
          textAlign: "left",
          width: 116,
          marginLeft: 5,
          marginTop: 10,
          fontFamily: `Poppins, sans-serif`,
        }}
      >
        <div style={{ fontSize: 10, color: "#2D2D2D" }}>Chicken Burger</div>
        <div style={{ fontSize: 12, color: "#FF0000" }}>Tk 250</div>
      </div>

      <FlexDivRow style={{ width: 70, marginTop: 25 }}>
        <FlexCenter onClick={handleDicrement}>-</FlexCenter>

        <div
          style={{
            fontSize: 12,
            fontFamily: `Poppins, sans-serif`,
          }}
        >
          {counter}
        </div>

        <FlexCenter onClick={() => setCounter(counter + 1)}>+</FlexCenter>
      </FlexDivRow>

      <div
        style={{
          background: "#C4C4C4",
          width: 17,
          height: 17,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "#FFF",
          fontSize: 12,
          fontFamily: `Poppins, sans-serif`,
        }}
      >
        X
      </div>
    </FlexDivRow>
  );
};

export default CardItem;
